import { getOptimizedImageURL } from '@epilot/journey-logic-commons'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Image, Card } from '../../components'
import { useIsMobile } from '../../utils'

import classes from './ImageControl.module.scss'

const OPTIMAL_IMAGE_WIDTH = '1200'

type Width = '100%' | '50%' | '30%'

export const ImageControl = ({
  IMAGE_PREVIEW_API_URL,
  id,
  url,
  altText,
  stepBlockId,
  width
}: {
  IMAGE_PREVIEW_API_URL: string
  id: string
  url: string
  altText: string
  stepBlockId: string
  width: Width
}) => {
  const { t } = useTranslation()

  const optimizedImageURL = useMemo(
    () =>
      getOptimizedImageURL(IMAGE_PREVIEW_API_URL, url, id, OPTIMAL_IMAGE_WIDTH),
    [id, url, IMAGE_PREVIEW_API_URL]
  )

  const image = (
    <Image
      alt={altText}
      className={classes.image}
      data-testid="image-control"
      id={stepBlockId}
      src={optimizedImageURL}
    />
  )

  const isMobile = useIsMobile()

  return (
    <>
      {optimizedImageURL ? (
        <div className={classes.container}>
          <div className={isMobile ? classes.mobileDiv : getWidthClass(width)}>
            {image}
          </div>
        </div>
      ) : (
        <Card className={classes.cardContent} noHover>
          {t('no_image_text')}
          {image}
        </Card>
      )}
    </>
  )
}

const getWidthClass = (width: Width) => {
  switch (width) {
    case '100%':
      return classes.flex100
    case '50%':
      return classes.flex50
    case '30%':
      return classes.flex30
    default:
      return classes.flex100
  }
}
